<template>
  <div class="info-container">
    <AppNavbar
      class="nav-bar"
      :title="title"
      :options="options"
      :zIndex="10"
    ></AppNavbar>
    <img
      class="bg"
      src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/9478ba352158974faa2fc3a53fbac57f.png"
      alt=""
    />
    <div>
      <div class="title">
        <div class="hello">Hello！</div>
        <div
          class="nickname"
          :style="{ opacity: userInfo && userInfo.truename ? 1 : 0 }"
          >{{ userInfo && userInfo.truename }}</div
        >
      </div>
      <div class="desc">欢迎使用彩虹杯</div>
      <div class="user-form">
        <div class="tip">
          我们将根据您的身体情况，定制最适合您的补水方案，请先填写以下信息
        </div>
        <div class="user-title">您的性别是？</div>
        <div class="gender">
          <div
            class="gender-item"
            :class="{ 'gender-item-active': curGender == item.id }"
            v-for="(item, index) in genderList"
            :key="index"
            @click="bindChangeGender(item)"
          >
            <span class="iconfont" :class="[item.icon]"></span
            ><span>{{ item.name }}</span>
          </div>
        </div>
        <div class="user-title">您的体重是？</div>
        <div class="cs-number">
          <span>{{ rulerNum }}</span>
          <div class="cs-unit">KG</div>
        </div>
        <CsRuler
          class="cs-rules"
          @change="bindRulerNum"
          :NowNum="defaultNum"
          :maxNum="maxNum"
          :minNum="minNum"
        ></CsRuler>
        <div class="btn" @click="createPlan">一键生成饮水方案</div>
      </div>
    </div>
    <MyToast
      :options="toastOptions"
      v-model="showToast"
      @confirm="bindConfirm"
    ></MyToast>
  </div>
</template>
<script>
import AppNavbar from '@/components/app/nav-bar/index.vue'
import MyToast from './components/toast.vue'
import CsRuler from '@/components/app/ruler/ruler.vue'
export default {
  components: {
    AppNavbar,
    CsRuler,
    MyToast
  },
  data() {
    return {
      title: '方案定制',
      options: {
        barBackgroundColor: 'transparent',
        color: '#fff'
      },
      genderList: [
        {
          id: '1',
          name: '男',
          icon: 'icon-nansheng'
        },
        {
          id: '2',
          name: '女',
          icon: 'icon-nvsheng'
        }
      ],
      curGender: 0,
      toastOptions: {},
      showToast: false,
      rulerNum: 60, // 刻度尺当前值
      defaultNum: 60, //刻度尺默认值
      minNum: 20,
      maxNum: 200,
      userInfo: null
    }
  },
  created() {
    this.getUserInfo()
  },
  mounted() {
    document.addEventListener('scroll', this.bindScroll)
  },
  beforeDestroy() {
    document.removeEventListener('scroll', this.bindScroll)
  },
  methods: {
    getUserInfo() {
      this.$http
        .getBaseApp('member/WaterClock/getUserInfo', {})
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.userInfo = res.data
            this.curGender = res.data.gender
            let weight = parseFloat(res.data.weight)
            this.setInitWeight(weight)
          } else {
            this.$toast(res.msg)
          }
        })
        .catch(() => {})
    },
    setInitWeight(weight) {
      if (weight <= 0) {
        return
      }
      let res = this.defaultNum
      if (weight < this.minNum) {
        res = this.minNum
      } else if (weight > this.maxNum) {
        res = this.maxNum
      } else {
        res = weight
      }
      this.defaultNum = res
      this.rulerNum = res
    },
    bindScroll(e) {
      let scrollTop = e.target.documentElement.scrollTop
      if (scrollTop <= 20) {
        this.options = {
          barBackgroundColor: 'transparent',
          color: '#fff'
        }
      } else {
        this.options = {
          barBackgroundColor: '#fff'
        }
      }
    },
    bindChangeGender(item) {
      this.curGender = item.id
    },
    createPlan() {
      this.crateDrinkPlan()
    },
    crateDrinkPlan() {
      let params = {
        weight: this.rulerNum,
        gender: this.curGender
      }
      this.$http
        .postBaseApp('member/WaterClock/createSchedule', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            if (this.$route.query.change) {
              this.toastOptions = {
                title: '修改成功！',
                message: '新的喝水方案将从明日生效，<br/>让我们坚持好好喝水吧！'
              }
              this.showToast = true
            } else {
              switch (this.$route.query.from) {
                case 'normalSet':
                  this.$store.commit('drinkWater/setNeedUpdate', true)
                  this.$router.go(-2)
                  break
                case 'normalHome':
                  this.$store.commit('drinkWater/setNeedUpdate', true)
                  this.$router.go(-1)
                  break
                default:
                  this.$router.replace({
                    path: '/drink-water-reminder/generate',
                    query: {
                      type: 'create'
                    }
                  })
              }
            }
          } else {
            this.$toast(res.msg)
          }
        })
        .catch(() => {})
    },
    bindConfirm() {
      this.$router.go(-1)
    },
    bindRulerNum(val) {
      this.rulerNum = val
    }
  }
}
</script>
<style lang="scss" scoped>
.info-container {
  position: relative;
  min-height: 100vh;
  background: #ffffff;
  overflow: hidden;
  z-index: 0;
  padding: 20px;
  box-sizing: border-box;

  .bg {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    object-fit: contain;
    z-index: -1;
  }

  .title {
    font-size: 34px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #ffffff;
    line-height: 46px;
    margin-top: 89px;
    margin-bottom: 5px;
  }

  .hello {
    margin-top: 89px;
  }

  .nickname {
    min-height: 46px;
    opacity: 0;
    transition: all 0.3s ease;
  }

  .desc {
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    line-height: 28px;
    margin-bottom: 26px;
  }

  .user-form {
    background: #ffffff;
    border-radius: 12px;
    padding: 20px;
    box-sizing: border-box;

    .tip {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.5);
      line-height: 17px;
      margin-bottom: 30px;
    }

    .user-title {
      position: relative;
      padding-left: 9px;
      font-size: 18px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: rgba(0, 0, 0, 0.8);
      line-height: 25px;
      margin-bottom: 24px;
    }

    .user-title::after {
      content: '';
      position: absolute;
      left: 0;
      top: 50%;
      transform: translate(0%, -50%);
      width: 3px;
      height: 18px;
      background: #6b24ff;
    }

    .gender {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 47px;

      .gender-item {
        text-align: center;
        width: 138px;
        height: 50px;
        border-radius: 6px;
        border: 2px solid rgba(107, 36, 255, 0.3);
        line-height: 50px;
        color: rgba(98, 54, 255, 0.4);
        font-size: 18px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;

        .iconfont {
          margin-right: 10px;
          font-size: 18px;
        }
      }

      .gender-item-active {
        border: 2px solid rgba(98, 54, 255, 1);
        color: rgba(98, 54, 255, 1);
      }
    }

    .cs-rules {
      margin-bottom: 51px;
    }

    .cs-number {
      display: flex;
      align-items: flex-end;
      justify-content: center;
      font-size: 40px;
      font-family: DINCondensed-Bold, DINCondensed;
      color: #6236ff;
      line-height: 30px;
      margin-bottom: 10px;
    }

    .cs-unit {
      font-size: 16px;
      font-family: DIN-Medium, DIN;
      font-weight: 500;
      color: #6236ff;
      line-height: 19px;
    }

    .btn {
      width: 295px;
      height: 42px;
      background: #6236ff;
      border-radius: 12px;
      margin: 0 auto;
      text-align: center;
      line-height: 42px;
      font-size: 16px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #ffffff;
      line-height: 42px;
      margin-bottom: 40px;
    }
  }
}
</style>
